import React, { useState, useEffect } from "react";
import LayoutV2 from "containers/LayoutV2";
import "react-dropdown/style.css";
import { SearchBar } from "./SearchBar";
// import { AddNhanVayDeskTopBtn } from "./AddNhanVayDesktop";
import { TableDanhSach } from "./TableDanhSach";
import { useSelector, useDispatch } from "react-redux";
import StoreApi from "../../service/phanQuyenApi";
import DongTienNhanhApi from "../../service/dongTienNhanhApi";
import Pagination from "react-js-pagination";
import CauHinhApi from "../../service/cauHinhApi";
import cauHinh from "utils/cauHinh";

export const DongTienNhanh = () => {
  useEffect(() => {
    document.title = "Đóng tiền nhanh | Phần mềm quản lý cầm đồ Morman";
  }, []);

  const dispatch = useDispatch();
  const initPhanQuyen = { dongtiennhanh: false };
  const initSearch = {
    iStatus: "0",
    sSearch: "",
    iPageIndex: 1,
    iPageSize: 20,
    iType: "0",
    sMaNhanVien: "",
  };
  const [dataSearch, setDataSearch] = useState(initSearch);
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [listDataDanhSach, setListDanhSach] = useState({ List: [] });
  const [isQRThanhToan, setIsQRThanhToan] = useState(false);
  const [isDisableXacNhan, setDisableXacNhan] = useState(false);
  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenDongTienNhanh().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        dongtiennhanh: response.data.dongtiennhanh,
      });
    });
  };
  useEffect(() => {
    LoadPhanQuyen();
    onSearch(dataSearch);

    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const configIsQRThanhToan = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQRThanhToan.toUpperCase()
          );
          if (configIsQRThanhToan != null) {
            if (configIsQRThanhToan.valueConfig === "1") {
              setIsQRThanhToan(true);
            }
          }
        }
      }
    });
  }, []);

  const onSearch = (data) => {
    DongTienNhanhApi.list({
      iStatus: data.iStatus,
      sSearch: data.sSearch,
      iPageIndex: data.iPageIndex,
      iPageSize: data.iPageSize,
      iType: data.iType,
      sMaNhanVien: data.sMaNhanVien,
    }).then((response) => {
      if (response.status == "200") {
        setListDanhSach(response.data);
      }
    });
  };
  const handlePageChange = (pageNumber) => {
    dataSearch.iPageIndex = pageNumber;
    setDataSearch(dataSearch);
    onSearch(dataSearch);
  };
  return (
    <LayoutV2>
      {phanQuyen.dongtiennhanh && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Đóng tiền nhanh</h1>
                        </div>
                      </div>{" "}
                    </div>{" "}
                  </div>{" "}
                </div>
                <SearchBar
                  onSearch={onSearch}
                  setDataSearch={setDataSearch}
                  dataSearch={dataSearch}
                />
              </div>
            </div>
            <div className="col-12">
              <div
                className="card border-light mb-1 card-v2"
                style={{
                  marginTop: "-35px",
                }}
              >
                <div
                  className={
                    "loader loader-default " +
                    (isDisableXacNhan ? "is-active" : "")
                  }
                ></div>
                <div className="loading-page1"></div>{" "}
                <TableDanhSach
                  onSearch={onSearch}
                  listDataDanhSach={listDataDanhSach}
                  setDataSearch={setDataSearch}
                  dataSearch={dataSearch}
                  isQRThanhToan={isQRThanhToan}
                  setDisableXacNhan = {setDisableXacNhan}
                />
              </div>
              <div className="card border-light mb-3 card-v2">
                <div className="card-body card-body-v2">
                  <div className="row">
                    <div className="col-sm-12 col-md-6">
                      <span className="color7">
                        {listDataDanhSach.iTotal === 0 ? (
                          "Hiển thị 0 - 0 / Tổng số 0"
                        ) : (
                          <>
                            Hiển thị{" "}
                            {(dataSearch.iPageIndex - 1) *
                              dataSearch.iPageSize +
                              1}{" "}
                            -{" "}
                            {Math.min(
                              dataSearch.iPageIndex * dataSearch.iPageSize,
                              listDataDanhSach.iTotal
                            )}{" "}
                            / Tổng số {listDataDanhSach.iTotal}
                          </>
                        )}
                      </span>
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <div
                        className={
                          "paniation-new paniation-new1 d-flex justify-content-center " +
                          (listDataDanhSach.iTotal === 0 ? "hidden" : "")
                        }
                        style={{ float: "right" }}
                      >
                        <nav aria-label="Page navigation">
                          <Pagination
                            activePage={dataSearch.iPageIndex}
                            itemsCountPerPage={dataSearch.iPageSize}
                            totalItemsCount={listDataDanhSach.iTotal}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                            itemClass="page-item border-none"
                            linkClass="page-link border-none"
                            activeClass="active"
                          />
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      )}
      {!phanQuyen.dongtiennhanh && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Đóng tiền nhanh</h1>
                        </div>
                      </div>{" "}
                    </div>{" "}
                  </div>{" "}
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
